/* Browse band: tab switching, and the class that retires the facet sidebar.
   Markup in snippets/nvwa-browse.liquid, styling in assets/nvwa-browse.css.

   8 Sep 2026. Deliberately small. Everything that matters about this band is
   server rendered: the tiles are real links to native ?filter.p.m.* URLs, the
   numbers on them are Shopify's own filter_value.count, and WHICH PANEL OPENS
   is decided in Liquid. So with this script blocked the page still filters,
   still shows honest counts, and still arrives on the right tab -- it just
   shows every panel at once and keeps the sidebar. A worse layout, a working
   page.

   THE ORDER OF THE TWO JOBS BELOW IS THE POINT. nv-browse-ready is what hides
   the facet sidebar and the theme's own filter button, and it is set ONLY
   after a rendered panel has been found. A filter control is not something to
   hide behind a script that might not load. */
(function () {
  'use strict';

  var band = document.querySelector('[data-nvl-browse]');
  if (!band) { return; }

  var tabs = band.querySelectorAll('[data-nvl-tab]');
  var panels = band.querySelectorAll('[data-nvl-panel]');

  /* No panel means Search & Discovery has none of these filters configured and
     Liquid rendered a shell -- which it is written not to do, but the sidebar
     is not getting hidden on the strength of that. */
  if (!panels.length) { return; }

  document.documentElement.classList.add('nv-browse-ready');

  /* Toggle the `hidden` attribute rather than an inline display value, so the
     rule in nvwa-browse.css stays the single source of how a panel is hidden.
     That rule needs !important because .nvl-tiles is display:grid, which
     outranks the UA stylesheet's [hidden]{display:none} -- the same defeat
     that once shipped the level finder showing all three levels. */
  Array.prototype.forEach.call(tabs, function (tab) {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      var want = tab.getAttribute('data-nvl-tab');

      Array.prototype.forEach.call(tabs, function (t) {
        t.setAttribute('aria-current', String(t.getAttribute('data-nvl-tab') === want));
      });
      Array.prototype.forEach.call(panels, function (p) {
        p.hidden = p.getAttribute('data-nvl-panel') !== want;
      });
    });
  });
})();
